// Shared CRM theme token map — CSS variable references
const T = {
  bg: 'var(--bg)',
  surface: 'var(--surface)',
  surface2: 'var(--surface2)',
  border: 'var(--border)',
  borderLight: 'var(--surface2)',
  text: 'var(--text)',
  textMuted: 'var(--text-muted)',
  textDim: 'var(--text-dim)',
  teal: 'var(--teal)',
  tealDim: 'var(--teal-dim)',
  tealGlow: 'var(--teal-glow)',
  cardBg: 'var(--card-bg)',
  cardBorder: 'var(--card-border)',
  colBg: 'var(--col-bg)',
  tagBg: 'var(--tag-bg)',
  inputBg: 'var(--input-bg)',
  shadow: 'var(--card-shadow)',
  shadowHover: 'var(--card-shadow-hover)',
};

export default T;
